/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ExceptionResponseDTO } from '../model/exception-response-dto';
// @ts-ignore
import { GetProfiloServizio409Response } from '../model/get-profilo-servizio409-response';
// @ts-ignore
import { GetProfiloServizio422Response } from '../model/get-profilo-servizio422-response';
// @ts-ignore
import { Pageable } from '../model/pageable';
// @ts-ignore
import { PagedModelTipoPraticaRegolaPunteggioPredicatoDTO } from '../model/paged-model-tipo-pratica-regola-punteggio-predicato-dto';
// @ts-ignore
import { TipoPraticaRegolaPunteggioPredicatoCreationForm } from '../model/tipo-pratica-regola-punteggio-predicato-creation-form';
// @ts-ignore
import { TipoPraticaRegolaPunteggioPredicatoDTO } from '../model/tipo-pratica-regola-punteggio-predicato-dto';
// @ts-ignore
import { TipoPraticaRegolaPunteggioPredicatoListFilter } from '../model/tipo-pratica-regola-punteggio-predicato-list-filter';
// @ts-ignore
import { TipoPraticaRegolaPunteggioPredicatoPatchForm } from '../model/tipo-pratica-regola-punteggio-predicato-patch-form';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    TipoPraticaRegolaPunteggioPredicatoControllerServiceInterface,
    CreateTipoPraticaRegolaPunteggioPredicatoRequestParams,
    DeleteTipoPraticaRegolaPunteggioPredicatoRequestParams,
    GetTipoPraticaRegolaPunteggioPredicatoRequestParams,
    ListTipoPraticaRegolaPunteggioPredicatiRequestParams,
    UpdateTipoPraticaRegolaPunteggioPredicatoRequestParams
} from './tipo-pratica-regola-punteggio-predicato-controller.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class TipoPraticaRegolaPunteggioPredicatoControllerService extends BaseService implements TipoPraticaRegolaPunteggioPredicatoControllerServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Crea un nuovo predicato della regola
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/regola-punteggio-categorie/{idCategoria}/regole/{idRegola}/predicati
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public createTipoPraticaRegolaPunteggioPredicato(requestParameters: CreateTipoPraticaRegolaPunteggioPredicatoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TipoPraticaRegolaPunteggioPredicatoDTO>;
    public createTipoPraticaRegolaPunteggioPredicato(requestParameters: CreateTipoPraticaRegolaPunteggioPredicatoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TipoPraticaRegolaPunteggioPredicatoDTO>>;
    public createTipoPraticaRegolaPunteggioPredicato(requestParameters: CreateTipoPraticaRegolaPunteggioPredicatoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TipoPraticaRegolaPunteggioPredicatoDTO>>;
    public createTipoPraticaRegolaPunteggioPredicato(requestParameters: CreateTipoPraticaRegolaPunteggioPredicatoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling createTipoPraticaRegolaPunteggioPredicato.');
        }
        const idCategoria = requestParameters?.idCategoria;
        if (idCategoria === null || idCategoria === undefined) {
            throw new Error('Required parameter idCategoria was null or undefined when calling createTipoPraticaRegolaPunteggioPredicato.');
        }
        const idRegola = requestParameters?.idRegola;
        if (idRegola === null || idRegola === undefined) {
            throw new Error('Required parameter idRegola was null or undefined when calling createTipoPraticaRegolaPunteggioPredicato.');
        }
        const tipoPraticaRegolaPunteggioPredicatoCreationForm = requestParameters?.tipoPraticaRegolaPunteggioPredicatoCreationForm;
        if (tipoPraticaRegolaPunteggioPredicatoCreationForm === null || tipoPraticaRegolaPunteggioPredicatoCreationForm === undefined) {
            throw new Error('Required parameter tipoPraticaRegolaPunteggioPredicatoCreationForm was null or undefined when calling createTipoPraticaRegolaPunteggioPredicato.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/regola-punteggio-categorie/${this.configuration.encodeParam({name: "idCategoria", value: idCategoria, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/regole/${this.configuration.encodeParam({name: "idRegola", value: idRegola, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/predicati`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TipoPraticaRegolaPunteggioPredicatoDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: tipoPraticaRegolaPunteggioPredicatoCreationForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Elimina un predicato della regola
     * @endpoint delete /api/v1/gestione/tipi-pratica/{idTipoPratica}/regola-punteggio-categorie/{idCategoria}/regole/{idRegola}/predicati/{idPredicato}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public deleteTipoPraticaRegolaPunteggioPredicato(requestParameters: DeleteTipoPraticaRegolaPunteggioPredicatoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public deleteTipoPraticaRegolaPunteggioPredicato(requestParameters: DeleteTipoPraticaRegolaPunteggioPredicatoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public deleteTipoPraticaRegolaPunteggioPredicato(requestParameters: DeleteTipoPraticaRegolaPunteggioPredicatoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public deleteTipoPraticaRegolaPunteggioPredicato(requestParameters: DeleteTipoPraticaRegolaPunteggioPredicatoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling deleteTipoPraticaRegolaPunteggioPredicato.');
        }
        const idCategoria = requestParameters?.idCategoria;
        if (idCategoria === null || idCategoria === undefined) {
            throw new Error('Required parameter idCategoria was null or undefined when calling deleteTipoPraticaRegolaPunteggioPredicato.');
        }
        const idRegola = requestParameters?.idRegola;
        if (idRegola === null || idRegola === undefined) {
            throw new Error('Required parameter idRegola was null or undefined when calling deleteTipoPraticaRegolaPunteggioPredicato.');
        }
        const idPredicato = requestParameters?.idPredicato;
        if (idPredicato === null || idPredicato === undefined) {
            throw new Error('Required parameter idPredicato was null or undefined when calling deleteTipoPraticaRegolaPunteggioPredicato.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/regola-punteggio-categorie/${this.configuration.encodeParam({name: "idCategoria", value: idCategoria, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/regole/${this.configuration.encodeParam({name: "idRegola", value: idRegola, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/predicati/${this.configuration.encodeParam({name: "idPredicato", value: idPredicato, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Dettaglio di un predicato della regola
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/regola-punteggio-categorie/{idCategoria}/regole/{idRegola}/predicati/{idPredicato}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getTipoPraticaRegolaPunteggioPredicato(requestParameters: GetTipoPraticaRegolaPunteggioPredicatoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TipoPraticaRegolaPunteggioPredicatoDTO>;
    public getTipoPraticaRegolaPunteggioPredicato(requestParameters: GetTipoPraticaRegolaPunteggioPredicatoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TipoPraticaRegolaPunteggioPredicatoDTO>>;
    public getTipoPraticaRegolaPunteggioPredicato(requestParameters: GetTipoPraticaRegolaPunteggioPredicatoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TipoPraticaRegolaPunteggioPredicatoDTO>>;
    public getTipoPraticaRegolaPunteggioPredicato(requestParameters: GetTipoPraticaRegolaPunteggioPredicatoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling getTipoPraticaRegolaPunteggioPredicato.');
        }
        const idCategoria = requestParameters?.idCategoria;
        if (idCategoria === null || idCategoria === undefined) {
            throw new Error('Required parameter idCategoria was null or undefined when calling getTipoPraticaRegolaPunteggioPredicato.');
        }
        const idRegola = requestParameters?.idRegola;
        if (idRegola === null || idRegola === undefined) {
            throw new Error('Required parameter idRegola was null or undefined when calling getTipoPraticaRegolaPunteggioPredicato.');
        }
        const idPredicato = requestParameters?.idPredicato;
        if (idPredicato === null || idPredicato === undefined) {
            throw new Error('Required parameter idPredicato was null or undefined when calling getTipoPraticaRegolaPunteggioPredicato.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/regola-punteggio-categorie/${this.configuration.encodeParam({name: "idCategoria", value: idCategoria, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/regole/${this.configuration.encodeParam({name: "idRegola", value: idRegola, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/predicati/${this.configuration.encodeParam({name: "idPredicato", value: idPredicato, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TipoPraticaRegolaPunteggioPredicatoDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lista paginata dei predicati della regola (filtri: fonte, operatore)
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/regola-punteggio-categorie/{idCategoria}/regole/{idRegola}/predicati
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listTipoPraticaRegolaPunteggioPredicati(requestParameters: ListTipoPraticaRegolaPunteggioPredicatiRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PagedModelTipoPraticaRegolaPunteggioPredicatoDTO>;
    public listTipoPraticaRegolaPunteggioPredicati(requestParameters: ListTipoPraticaRegolaPunteggioPredicatiRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PagedModelTipoPraticaRegolaPunteggioPredicatoDTO>>;
    public listTipoPraticaRegolaPunteggioPredicati(requestParameters: ListTipoPraticaRegolaPunteggioPredicatiRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PagedModelTipoPraticaRegolaPunteggioPredicatoDTO>>;
    public listTipoPraticaRegolaPunteggioPredicati(requestParameters: ListTipoPraticaRegolaPunteggioPredicatiRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling listTipoPraticaRegolaPunteggioPredicati.');
        }
        const idCategoria = requestParameters?.idCategoria;
        if (idCategoria === null || idCategoria === undefined) {
            throw new Error('Required parameter idCategoria was null or undefined when calling listTipoPraticaRegolaPunteggioPredicati.');
        }
        const idRegola = requestParameters?.idRegola;
        if (idRegola === null || idRegola === undefined) {
            throw new Error('Required parameter idRegola was null or undefined when calling listTipoPraticaRegolaPunteggioPredicati.');
        }
        const filter = requestParameters?.filter;
        if (filter === null || filter === undefined) {
            throw new Error('Required parameter filter was null or undefined when calling listTipoPraticaRegolaPunteggioPredicati.');
        }
        const pageable = requestParameters?.pageable;
        if (pageable === null || pageable === undefined) {
            throw new Error('Required parameter pageable was null or undefined when calling listTipoPraticaRegolaPunteggioPredicati.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'filter',
            <any>filter,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'pageable',
            <any>pageable,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/regola-punteggio-categorie/${this.configuration.encodeParam({name: "idCategoria", value: idCategoria, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/regole/${this.configuration.encodeParam({name: "idRegola", value: idRegola, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/predicati`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PagedModelTipoPraticaRegolaPunteggioPredicatoDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Replace di un predicato della regola (richiede version)
     * @endpoint put /api/v1/gestione/tipi-pratica/{idTipoPratica}/regola-punteggio-categorie/{idCategoria}/regole/{idRegola}/predicati/{idPredicato}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public updateTipoPraticaRegolaPunteggioPredicato(requestParameters: UpdateTipoPraticaRegolaPunteggioPredicatoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TipoPraticaRegolaPunteggioPredicatoDTO>;
    public updateTipoPraticaRegolaPunteggioPredicato(requestParameters: UpdateTipoPraticaRegolaPunteggioPredicatoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TipoPraticaRegolaPunteggioPredicatoDTO>>;
    public updateTipoPraticaRegolaPunteggioPredicato(requestParameters: UpdateTipoPraticaRegolaPunteggioPredicatoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TipoPraticaRegolaPunteggioPredicatoDTO>>;
    public updateTipoPraticaRegolaPunteggioPredicato(requestParameters: UpdateTipoPraticaRegolaPunteggioPredicatoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling updateTipoPraticaRegolaPunteggioPredicato.');
        }
        const idCategoria = requestParameters?.idCategoria;
        if (idCategoria === null || idCategoria === undefined) {
            throw new Error('Required parameter idCategoria was null or undefined when calling updateTipoPraticaRegolaPunteggioPredicato.');
        }
        const idRegola = requestParameters?.idRegola;
        if (idRegola === null || idRegola === undefined) {
            throw new Error('Required parameter idRegola was null or undefined when calling updateTipoPraticaRegolaPunteggioPredicato.');
        }
        const idPredicato = requestParameters?.idPredicato;
        if (idPredicato === null || idPredicato === undefined) {
            throw new Error('Required parameter idPredicato was null or undefined when calling updateTipoPraticaRegolaPunteggioPredicato.');
        }
        const tipoPraticaRegolaPunteggioPredicatoPatchForm = requestParameters?.tipoPraticaRegolaPunteggioPredicatoPatchForm;
        if (tipoPraticaRegolaPunteggioPredicatoPatchForm === null || tipoPraticaRegolaPunteggioPredicatoPatchForm === undefined) {
            throw new Error('Required parameter tipoPraticaRegolaPunteggioPredicatoPatchForm was null or undefined when calling updateTipoPraticaRegolaPunteggioPredicato.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/regola-punteggio-categorie/${this.configuration.encodeParam({name: "idCategoria", value: idCategoria, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/regole/${this.configuration.encodeParam({name: "idRegola", value: idRegola, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/predicati/${this.configuration.encodeParam({name: "idPredicato", value: idPredicato, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TipoPraticaRegolaPunteggioPredicatoDTO>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: tipoPraticaRegolaPunteggioPredicatoPatchForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
